export enum PermissionNames {
  // main
  // Two screens, two permissions: MAIN_HOME_VIEW gates /home, while
  // MAIN_DASHBOARD_VIEW gates the dashboard each user assembles at
  // /dashboard. Home was carved out of MAIN_DASHBOARD_VIEW, which used to
  // gate both when they were one screen.
  MAIN_DASHBOARD_VIEW = "main-dashboard-view",
  MAIN_HOME_VIEW = "main-home-view",
  SETTING_MANAGE = "setting-manage",
  // Cross-product: run a report for agents other than yourself. Without it,
  // every report's agent filter is pinned to the logged-in user.
  ALL_REPORTS_SHOW_OTHERS = "all-reports-show-others",

  USER_SHOW = "user-show",
  USER_CREATE = "user-create",
  USER_UPDATE = "user-update",
  USER_DELETE = "user-delete",
  USER_EXPORT = "user-export",

  ROLE_SHOW = "role-show",
  ROLE_CREATE = "role-create",
  ROLE_UPDATE = "role-update",
  ROLE_DELETE = "role-delete",

  PROFILE_SHOW = "profile-show",
  PROFILE_SHOW_OTHERS = "profile-show-others",
  PROFILE_CREATE = "profile-create",
  PROFILE_UPDATE = "profile-update",
  PROFILE_EXPORT = "profile-export",

  PRODUCT_SHOW = "product-show",
  // Stock is its own capability: correcting a product's name is a typo,
  // correcting what is on a shelf is money.
  STOCK_SHOW = "stock-show",
  STOCK_UPDATE = "stock-update",
  STOCK_LOCATION_MANAGE = "stock-location-manage",
  PRODUCT_CREATE = "product-create",
  PRODUCT_UPDATE = "product-update",
  PRODUCT_DELETE = "product-delete",
  PRODUCT_EXPORT = "product-export",

  SEND_SMS = "send-sms",
  SMS_HISTORY_SHOW = "sms-history-show",
  SMS_HISTORY_SHOW_OTHERS = "sms-history-show-others",
  SMS_HISTORY_UPDATE = "sms-history-update",
  SMS_HISTORY_EXPORT = "sms-history-export",

  // cc
  MAKE_CALL = "make-call",
  CC_DASHBOARD_VIEW = "cc-dashboard-view",
  CC_REPORT_GENERATE = "cc-report-generate",

  CALL_HISTORY_SHOW = "call-history-show",
  CALL_HISTORY_SHOW_OTHERS = "call-history-show-others",
  CALL_HISTORY_UPDATE = "call-history-update",
  CALL_HISTORY_EXPORT = "call-history-export",

  UNHANDLED_CALL_HISTORY_SHOW = "unhandled-call-history-show",
  UNHANDLED_CALL_HISTORY_UPDATE = "unhandled-call-history-update",
  UNHANDLED_CALL_HISTORY_EXPORT = "unhandled-call-history-export",

  CALL_GROUP_SHOW = "call-group-show",
  CALL_GROUP_UPDATE = "call-group-update",

  CUSTOMER_SHOW = "customer-show",
  CUSTOMER_CREATE = "customer-create",
  CUSTOMER_UPDATE = "customer-update",
  CUSTOMER_DELETE = "customer-delete",
  CUSTOMER_EXPORT = "customer-export",

  // crm
  CRM_DASHBOARD_VIEW = "crm-dashboard-view",
  CRM_REPORT_GENERATE = "crm-report-generate",
  CRM_ACCOUNT_REPORT_GENERATE = "crm-account-report-generate",
  CRM_ACCOUNT_ALL_BRANCH_REPORT_GENERATE = "crm-account-all-branch-report-generate",

  LEAD_SHOW = "lead-show",
  LEAD_CREATE = "lead-create",
  LEAD_UPDATE = "lead-update",
  LEAD_DELETE = "lead-delete",
  LEAD_EXPORT = "lead-export",
  LEAD_ASSIGN_USER = "lead-assign-user",
  LEAD_UNASSIGN_USER = "lead-unassign-user",
  LEAD_UPDATE_STATUS = "lead-update-status",
  LEAD_FOLLOWUP_COMPLETE_OTHERS = "lead-followup-complete-others",
  LEAD_BUSINESS_AMOUNT_SHOW = "lead-business-amount-show",

  LEAD_STATUS_SHOW = "lead-status-show",
  LEAD_STATUS_CREATE = "lead-status-create",
  LEAD_STATUS_UPDATE = "lead-status-update",
  LEAD_STATUS_DELETE = "lead-status-delete",

  TARGET_SHOW = "target-show",
  TARGET_CREATE = "target-create",
  TARGET_UPDATE = "target-update",
  TARGET_DELETE = "target-delete",
  TARGET_EXPORT = "target-export",
  LEAD_STATUS_TARGET_SHOW_OTHERS = "lead-status-target-show-others",
  LEAD_PUBLIC_FORM_SUBMISSION_SHOW = "lead-public-form-submission-show",
  LEAD_PUBLIC_FORM_SUBMISSION_REVIEW = "lead-public-form-submission-review",
  LEAD_CONFIRMATION_FORM_SUBMISSION_SHOW = "lead-confirmation-form-submission-show",
  LEAD_CONFIRMATION_FORM_SUBMISSION_REVIEW = "lead-confirmation-form-submission-review",
  EXTERNAL_LEAD_SUBMISSION_SHOW = "external-lead-submission-show",
  EXTERNAL_LEAD_SUBMISSION_REVIEW = "external-lead-submission-review",
  LEAD_SHOW_OTHERS = "lead-show-others",

  OPPORTUNITY_SHOW = "opportunity-show",
  OPPORTUNITY_SHOW_OTHERS = "opportunity-show-others",
  OPPORTUNITY_CREATE = "opportunity-create",
  OPPORTUNITY_UPDATE = "opportunity-update",
  OPPORTUNITY_DELETE = "opportunity-delete",
  OPPORTUNITY_EXPORT = "opportunity-export",
  OPPORTUNITY_ASSIGN_USER = "opportunity-assign-user",
  OPPORTUNITY_UNASSIGN_USER = "opportunity-unassign-user",
  OPPORTUNITY_UPDATE_STAGE = "opportunity-update-stage",

  OPPORTUNITY_STAGE_SHOW = "opportunity-stage-show",
  OPPORTUNITY_STAGE_CREATE = "opportunity-stage-create",
  OPPORTUNITY_STAGE_UPDATE = "opportunity-stage-update",
  OPPORTUNITY_STAGE_DELETE = "opportunity-stage-delete",

  ORGANIZATION_SHOW = "organization-show",
  ORGANIZATION_CREATE = "organization-create",
  ORGANIZATION_UPDATE = "organization-update",
  ORGANIZATION_DELETE = "organization-delete",
  ORGANIZATION_EXPORT = "organization-export",

  PARTNER_SHOW = "partner-show",
  PARTNER_CREATE = "partner-create",
  PARTNER_UPDATE = "partner-update",
  PARTNER_DELETE = "partner-delete",

  QUOTE_SHOW = "quote-show",
  QUOTE_CREATE = "quote-create",
  QUOTE_UPDATE = "quote-update",
  QUOTE_DELETE = "quote-delete",
  QUOTE_EXPORT = "quote-export",

  PAYMENT_ITEM_SHOW = "payment-item-show",
  PAYMENT_ITEM_CREATE = "payment-item-create",
  PAYMENT_ITEM_UPDATE = "payment-item-update",
  PAYMENT_ITEM_DELETE = "payment-item-delete",

  INVOICE_SHOW = "invoice-show",
  INVOICE_CREATE = "invoice-create",

  LEAD_RECEIVABLE_CREATE = "lead-receivable-create",

  PAYMENT_CREATE = "payment-create",

  DISCOUNT_REQUEST_SHOW = "discount-request-show",
  DISCOUNT_REQUEST_CREATE = "discount-request-create",
  DISCOUNT_REQUEST_REVIEW = "discount-request-review",
  DISCOUNT_REQUEST_EXPORT = "discount-request-export",
  DISCOUNT_REQUEST_APPROVE = "discount-request-approve",

  PAYMENT_ITEM_EXPORT = "payment-item-export",
  PAYMENT_PRODUCT_ASSIGN = "payment-product-assign",
  PAYMENT_PRODUCT_UNASSIGN = "payment-product-unassign",

  CREDIT_NOTE_SHOW = "credit-note-show",
  CREDIT_NOTE_CREATE = "credit-note-create",

  // help-desk
  HELP_DESK_DASHBOARD_VIEW = "help-desk-dashboard-view",
  HELP_DESK_REPORT_GENERATE = "help-desk-report-generate",
  AI_AGENT_SHOW = "ai-agent-show",
  AI_TICKET_SHOW = "ai-ticket-show",

  PAGE_ADD = "page-add",
  PAGE_SHOW = "page-show",
  PAGE_DELETE = "page-delete",

  TICKET_SHOW = "ticket-show",
  TICKET_SHOW_OTHERS = "ticket-show-others",
  TICKET_UPDATE = "ticket-update",
  TICKET_PICK = "ticket-pick",
  TICKET_EXPORT = "ticket-export",
  TICKET_ASSIGN = "ticket-assign",
  TICKET_TRANSFER = "ticket-transfer",
  TICKET_INBOX_SHOW = "ticket-inbox-show",

  REPLY_TEMPLATE_SHOW = "reply-template-show",
  REPLY_TEMPLATE_SHOW_OTHERS = "reply-template-show-others",
  REPLY_TEMPLATE_CREATE = "reply-template-create",
  REPLY_TEMPLATE_UPDATE = "reply-template-update",
  REPLY_TEMPLATE_DELETE = "reply-template-delete",

  WHATSAPP_CAMPAIGN_SHOW = "whatsapp-campaign-show",
  WHATSAPP_CAMPAIGN_CREATE = "whatsapp-campaign-create",
  WHATSAPP_CAMPAIGN_UPDATE = "whatsapp-campaign-update",
  WHATSAPP_CAMPAIGN_PROCESS = "whatsapp-campaign-process",
  WHATSAPP_CAMPAIGN_DELETE = "whatsapp-campaign-delete",

  // task-manager
  TASK_DASHBOARD_VIEW = "task-dashboard-view",

  TASK_SHOW = "task-show",
  TASK_SHOW_OTHERS = "task-show-others",
  TASK_CREATE = "task-create",
  TASK_UPDATE = "task-update",
  TASK_DELETE = "task-delete",
  TASK_EXPORT = "task-export",
  TASK_ASSIGN_USER = "task-assign-user",
  TASK_UNASSIGN_USER = "task-unassign-user",
  TASK_UPDATE_STATUS = "task-update-status",

  // telesales

  TELE_SALES_SHOW = "tele-sales-show",
  TELE_SALES_CREATE = "tele-sales-create",
  TELE_SALES_UPDATE = "tele-sales-update",
  TELE_SALES_DELETE = "tele-sales-delete",

  TELE_SALES_CUSTOMER_SHOW = "tele-sales-customer-show",
  TELE_SALES_CUSTOMER_CREATE = "tele-sales-customer-create",
  TELE_SALES_CUSTOMER_UPDATE = "tele-sales-customer-update",
  TELE_SALES_CUSTOMER_DELETE = "tele-sales-customer-delete",
  TELE_SALES_CUSTOMER_EXPORT = "tele-sales-customer-export",

  // auto-dialer
  AUTO_DIAL_SHOW = "auto-dial-show",
  AUTO_DIAL_CREATE = "auto-dial-create",
  AUTO_DIAL_UPDATE = "auto-dial-update",
  AUTO_DIAL_DELETE = "auto-dial-delete",
  AUTO_DIAL_EXPORT = "auto-dial-export",
  AUTO_DIAL_SHOW_OTHERS = "auto-dial-show-others",

  // order-manager
  ORDER_MANAGER_DASHBOARD_VIEW = "order-manager-dashboard-view",
  ORDER_MANAGER_REPORT_GENERATE = "order-manager-report-generate",
  ORDERS_SHOW = "order-show",
  ORDERS_CREATE = "order-create",
  ORDERS_UPDATE = "order-update",
  ORDERS_DELETE = "order-delete",
  ORDERS_EXPORT = "order-export",
  ORDERS_SUBMIT_TO_DELIVERY_PARTNER = "order-submit-to-delivery-partner",
  ORDERS_UPDATE_STATUS = "order-update-status",
  DELIVERY_PARTNER_INTEGRATION_SHOW = "delivery-partner-integration-show",
  DELIVERY_PARTNER_INTEGRATION_CREATE = "delivery-partner-integration-create",
  DELIVERY_PARTNER_INTEGRATION_UPDATE = "delivery-partner-integration-update",
  DELIVERY_PARTNER_INTEGRATION_DELETE = "delivery-partner-integration-delete",
  ORDER_AUTOMATION_SHOW = "order-automation-show",
  ORDER_AUTOMATION_CREATE = "order-automation-create",
  ORDER_AUTOMATION_UPDATE = "order-automation-update",
  ORDER_AUTOMATION_DELETE = "order-automation-delete",
  INCLUDE_IN_ORDER_MANAGER_REPORT = "include-in-order-manager-report",
}
